import { eDotTuyenSinhActionsObj } from "../../action-types/category/IDotTuyenSinhActions";
import { generateActions } from "../generateActions";

export const dotTuyenSinhActions = {
  ...generateActions(eDotTuyenSinhActionsObj, "DOT_TUYEN_SINH"),
};
